import { timestamps, uuid } from '@snap-types/models/common';
import { priceSegmentTypeSchema } from '@snap-types/models/price-segment/enums';
import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

export const columns = {
  uuid,

  snapQuoteLineUuid: uuid,

  segment: priceSegmentTypeSchema,
  matched: z.boolean(),
  priceAdjustment: decimal,
  // @NOTE(NT): This is kept as any to make TypeScript happy with Prisma's JSON column type
  // Use the resultsMetadataSchema to validate the resultsMetadata when needed
  resultsMetadata: z.any().nullish(),

  ...timestamps,
};
